<template lang="pug">
.btn-group
  button.btn.pagination-button.system-font(
    :disabled="isFirstPage",
    @click="setPage(1)") First
  button.btn.pagination-button.system-font(
    :disabled="isFirstPage",
    @click="setPage(pagination.current_page - 1)") Previous
  button.btn.pagination-button.system-font(v-for="i in pageList",
    :key="i",
    @click="setPage(i)",
    :class="{'selected-button' : i === currentPage}") {{i}}
  button.btn.pagination-button.system-font(
    :disabled="isLastPage",
    @click="setPage(pagination.current_page + 1)") Next
  button.btn.pagination-button.system-font(
    :disabled="isLastPage",
    @click="setPage(pagination.last_page)") Last
  button.btn.pagination-button.system-font(
    @click="setPageSize(pagination.total)") All
</template>

<script>
export default {
  name: 'PageNavigator',

  props: {
    pagination: { required: true }
  },

  computed: {
    isFirstPage () {
      return this.pagination.current_page === 1
    },

    isLastPage () {
      return this.pagination.current_page === this.pagination.last_page
    },

    pageList () {
      let totalPages = Math.ceil(this.pagination.total / this.pagination.per_page)
      let pages = []
      if (totalPages <= 10) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i)
        }
      } else {
        if (this.pagination.current_page < 6) {
          for (let i = 1; i <= 10; i++) {
            pages.push(i)
          }
        } else if (this.pagination.current_page > (this.pagination.last_page - 5)) {
          for (let i = this.pagination.last_page - 10; i <= this.pagination.last_page; i++) {
            pages.push(i)
          }
        } else {
          for (let i = this.pagination.current_page - 5; i <= this.pagination.current_page; i++) {
            pages.push(i)
          }

          for (let j = this.pagination.current_page + 1; j < this.pagination.current_page + 5; j++) {
            pages.push(j)
          }
        }
      }

      return pages
    },

    currentPage () {
      return this.pagination.current_page
    }
  },

  methods: {
    setPage (page) {
      this.$emit('setPage', page)
    },

    setPageSize (size) {
      this.$emit('setPageSize', size)
    }
  }
}
</script>

<style lang="sass" scoped>
  .pagination-button
    background-color: white
    color: #1b4e73
    border-color: #9b9b9b

  .selected-button
    color: white
    background-color: #428bca
    border-color: #428bca

  .system-font
    font-family: Arial, Helvetica, sans-serif
    font-size: 11px
</style>
